import moment from 'moment';

export const prepareQuery = (data) => {
  let query = '';
  if (data) {
    for (let d in data) {
      query += encodeURIComponent(d) + '=' + encodeURIComponent(data[d]) + '&';
    };
    query = query.slice(0, -1);
    return '?' + query;
  };
};

export const getFilteredData = (filterValues, data) => {
  let filteredData = [];

  filteredData = filterValues.min_score && (
    data.filter((i) => i.score >= parseInt(filterValues.min_score)));

  filteredData.length ? (filterValues.max_score &&
    (filteredData = filteredData.filter((i) =>
      i.score <= parseInt(filterValues.max_score)))) :
    (filteredData = data.filter((i) =>
      i.score <= parseInt(filterValues.max_score)));

  filteredData.length ? (filterValues.prevalence_info &&
    (filteredData = filteredData.filter((i) =>
      i.prevalence_info <= parseInt(filterValues.prevalence_info)))) :
    (filteredData = data.filter((i) =>
      i.prevalence_info <= parseInt(filterValues.prevalence_info)));

  filteredData.length ? (filterValues.category &&
    (filteredData = filteredData.filter((i) =>
      i.original_category === filterValues.category))) :
    (filteredData = data.filter((i) =>
      i.original_category === filterValues.category));

  filteredData.length ? (filterValues.tag &&
    (filteredData = filteredData.filter((i) => i.tag === filterValues.tag))) :
    (filteredData = data.filter((i) => i.tag === filterValues.tag));

  filteredData.length ? (filterValues.from &&
    (filteredData = filteredData.filter((i) =>
    (moment(i.last_updated_timestamp.split(' ')[0]).isAfter(filterValues.from) ||
      (moment(i.last_updated_timestamp.split(' ')[0]).isSame(filterValues.from)
      ))))) :
    (filteredData = data.filter((i) =>
    (moment(i.last_updated_timestamp.split(' ')[0]).isAfter(filterValues.from) ||
      (moment(i.last_updated_timestamp.split(' ')[0]).isSame(filterValues.from)
      ))));

  filteredData.length ? (filterValues.to &&
    (filteredData = filteredData.filter((i) =>
    (moment(i.last_updated_timestamp.split(' ')[0]).isBefore(filterValues.to) ||
      (moment(i.last_updated_timestamp.split(' ')[0]).isSame(filterValues.to)
      ))))) :
    (filteredData = data.filter((i) =>
    (moment(i.last_updated_timestamp.split(' ')[0]).isBefore(filterValues.to) ||
      (moment(i.last_updated_timestamp.split(' ')[0]).isSame(filterValues.to)
      ))));

  return filteredData;
};

export const dateFormatter = (date) => {
  let formattedDate;

  formattedDate = date.split('/');
  if (formattedDate[1].length == 1) formattedDate[1] = '0' + formattedDate[1];
  if (formattedDate[0].length == 1) formattedDate[0] = '0' + formattedDate[0];
  formattedDate = (formattedDate[2] + '-' + formattedDate[1] + '-' + formattedDate[0]);

  return formattedDate;
};

export const prepareCatForDropdown = (existingCategories) => {
  let catList = [];

  for (let i = 0; i < existingCategories.length; i++) {
    catList.push({
      key: i,
      text: existingCategories[i].detailed_category_name,
      value: existingCategories[i].detailed_category_name
    });
  };

  return catList;
};

export const setPayloadToSaveUrl = (revisedCat, isIgnored = false) => {
  let payload = {
    "revised_category": revisedCat,
    "is_ignored": isIgnored
  };

  return payload;
};

export const raiseEmptyData = (setAlertData) => {
  setAlertData({
    title: 'Absence Of Data',
    description: "You have no URLs to review. It's time to fetch new URLs!",
    eventName: 'Go back',
    showModal: true,
    type: 'info'
  });
};

export const raiseEmptyFetch = (setAlertData) => {
  setAlertData({
    title: "No URL Fetched.",
    description: 'Applied fiter has no match in database.',
    eventName: 'Go back',
    showModal: true,
    type: 'info'
  });
};

export const raiseNullInput = (setAlertData) => {
  setAlertData({
    title: 'Null Input',
    description: "Null value provided in revised category. Kindly update revised category.",
    eventName: "Ok! Let's change it",
    showModal: true,
    type: 'error'
  });
};